module.exports = __webpack_public_path__ + "img/Formula1_forceIndiaF1.89fbdd2a.jpg";